import React, { memo, useEffect, useState } from "react";
import styles from "./DashboardInput.module.css";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";

const DPhoneNumberInput = ({
  label,
  required = false,
  type,
  value,
  placeholder,
  customClassNameForInput,
  disabled,
  onChange,
  error,
  errorMsg,
  customClassName,
  size,
  numericOnly = false,
  maxDigits = 10,
}) => {
  const [inputValue, setInputValue] = useState();
  const [onchanged, setOnchanged] = useState(false);
  // const [isValidMobileNumber, setIsValidMobileNumber] = useState(false);
  // const [isCleared, setIsCleared] = useState();

  // useEffect(() => {
  //   setIsCleared(value && value.length === 0 ? true : false);
  // }, []);

  // console.log(value);

  let splitVal = value && value?.split(" ");

  const sanitizeDigits = (val) =>
    val === undefined || val === null ? "" : String(val).replace(/\D/g, "");

  const clampToMaxDigits = (val, limit) => {
    if (val === undefined || val === null) return "";
    if (!limit) return String(val);
    let digitsCount = 0;
    let output = "";
    for (const ch of String(val)) {
      if (/\d/.test(ch)) {
        if (digitsCount >= limit) continue;
        digitsCount += 1;
      }
      output += ch;
    }
    return output;
  };

  const clampDigitsOnly = (val, limit) =>
    sanitizeDigits(val).slice(0, limit || undefined);

  const clampValueWithDialCode = (val, dialCode, limit) => {
    const dialDigits = dialCode ? sanitizeDigits(dialCode) : "";
    const allowedDigits = limit
      ? limit + (dialDigits ? dialDigits.length : 0)
      : undefined;
    return clampToMaxDigits(val, allowedDigits);
  };

  useEffect(() => {
    if (value && value?.includes("+") && onchanged) {
      let valueShallowCopy = "";
      splitVal &&
        splitVal?.map((e, i) => {
          if (i !== 0) {
            valueShallowCopy += e;
          }
        });
      const sanitizedValue = numericOnly
        ? clampDigitsOnly(valueShallowCopy, maxDigits)
        : clampToMaxDigits(valueShallowCopy, maxDigits);
      setInputValue(sanitizedValue);
    } else {
      const nextValue = numericOnly
        ? clampDigitsOnly(value, maxDigits)
        : clampToMaxDigits(value, maxDigits);
      setInputValue(nextValue);
    }
  }, [value]);

  return (
    <div
      className={`${styles.d_input_container} ${
        disabled ? styles.diabledField : ""
      } ${customClassName}`}
      style={{ width: `${size}` }}
    >
      <label>
        {label}
        {required && <span className={styles.requiredMark}>*</span>}
      </label>
      <div className={`${styles.d_input_wrapper} ${error ? styles.error : ""}`}>
        <IntlTelInput
          placeholder={placeholder}
          autoPlaceholder={!placeholder}
          onPhoneNumberChange={(
            isValidMobileNumber,
            value,
            countryObject,
            valueWithCode
          ) => {
            // console.log(
            //   isValidMobileNumber,
            //   value,
            //   countryObject,
            //   valueWithCode
            // );
            setOnchanged(true);
            // setIsValidMobileNumber(isValidMobileNumber);
            const safeValue = numericOnly
              ? clampDigitsOnly(value, maxDigits)
              : clampToMaxDigits(value, maxDigits);
            const safeValueWithCode = numericOnly
              ? clampDigitsOnly(
                  valueWithCode,
                  maxDigits +
                    (countryObject?.dialCode
                      ? sanitizeDigits(countryObject.dialCode).length
                      : 0)
                )
              : clampValueWithDialCode(
                  valueWithCode,
                  countryObject?.dialCode,
                  maxDigits
                );
            const safeDigitsLength = sanitizeDigits(safeValue).length;
            const effectiveIsValid =
              isValidMobileNumber ||
              (maxDigits && safeDigitsLength === maxDigits);
            onChange &&
              onChange(
                safeValue,
                countryObject,
                effectiveIsValid,
                safeValueWithCode
              );
          }}
          onSelectFlag={(
            value,
            countryObject,
            valueWithCode,
            isValidMobileNumber
          ) => {
            let countryCodeSplitted = value && value?.split(" ");
            let countryCode =
              countryCodeSplitted[0] === `+${countryObject.dialCode}`;

            const formattedValue = countryCode === false ? "" : value;
            const safeValue = numericOnly
              ? clampDigitsOnly(value, maxDigits)
              : clampToMaxDigits(value, maxDigits);
            const safeFormattedValue = numericOnly
              ? clampDigitsOnly(
                  formattedValue,
                  maxDigits +
                    (countryObject?.dialCode
                      ? sanitizeDigits(countryObject.dialCode).length
                      : 0)
                )
              : clampValueWithDialCode(
                  formattedValue,
                  countryObject?.dialCode,
                  maxDigits
                );
            const safeDigitsLength = sanitizeDigits(safeValue).length;
            const effectiveIsValid =
              isValidMobileNumber ||
              (maxDigits && safeDigitsLength === maxDigits);

            onChange(
              safeValue,
              countryObject,
              effectiveIsValid,
              safeFormattedValue
            );
          }}
          defaultCountry="in"
          value={inputValue}
          autoHideDialCode={true}
          format={false}
          // separateDialCode={true}
        />

        {/* <PhoneInput
          value={value}
          onChange={onChange}
          enableSearch={false}
          copyNumbersOnly={false}
          autoFormat={true}
          disableSearchIcon={true}
          autocompleteSearch={true}
          disableInitialCountryGuess={false}
          disableCountryGuess={false}
          enableAreaCodes={true}
          disableCountryCode={false}
          country={"in"}
          countryCodeEditable={true}
          specialLabel=""
          searchNotFound="No country codes found."
          placeholder={`Enter ${label}`}
          // containerClass={!error ? styles.phoneInputContainerStyle : styles.phoneInputStyleError}
          inputClass={styles.phoneInputStyle}
          dropdownClass={styles.phoneInputDropDownStyle}
          inputProps={{ required: true }}
          searchStyle={{
            fontFamily: "Source Sans Regular",
            width: "95%",
            border: "1px solid #adadad50",
            padding: ".6rem 1.5rem",
          }}
        /> */}
      </div>

      {error && <p className={styles.error_message}>{errorMsg}</p>}
    </div>
  );
};

export default memo(DPhoneNumberInput);
